module.exports = __webpack_public_path__ + "static/media/copyIconExpandedRecords.537b2cad.svg";